import { render, staticRenderFns } from "./BaaFormWizard.vue?vue&type=template&id=2cee3744&scoped=true&"
import script from "./BaaFormWizard.vue?vue&type=script&lang=js&"
export * from "./BaaFormWizard.vue?vue&type=script&lang=js&"
import style0 from "./BaaFormWizard.vue?vue&type=style&index=0&id=2cee3744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee3744",
  null
  
)

export default component.exports